function manejarCookieCodigoPostal(valor) {
    let nombreCookie = "dotoCodigoPostal";

    if (valor === undefined) {
        // Obtener la cookie
        let cookieValor = document.cookie.split('; ').find(row => row.startsWith(nombreCookie + '='));
        return cookieValor ? cookieValor.split('=')[1] : null;
    } else if (valor === null) {
        // Eliminar la cookie
        document.cookie = nombreCookie + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    } else {
        // Crear o actualizar la cookie
        document.cookie = nombreCookie + "=" + valor + "; path=/;";
        // console.log("Cookie actualizada: " + valor)
    }
}


// Obtener el código postal (si existe) o crearlo con valor por defecto
let codigoPostal = manejarCookieCodigoPostal();
// console.log("Código Postal:", codigoPostal);

// Actualizar la cookie con un nuevo valor
// manejarCookieCodigoPostal("56647");
// console.log("Código Postal actualizado:", manejarCookieCodigoPostal());
